import { ErrorType } from './errorModal.model';

export class ResponseError extends Error {
  public errorType: ErrorType;
  public name: string;

  constructor(message: string, errorType: ErrorType = 'systemError') {
    super(message);
    if (errorType) {
      this.errorType = errorType;
    }
    this.name = 'responseError';
  }
}
